import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import styled from "styled-components";
import Back from "sushiweb/Icons/all/Back";
import Breadcrumb from "sushiweb/Breadcrumb";
import Button from "sushiweb/Button";
import { FlexContainer } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { getPath, isMobile, isValNull } from "../../../utils";
import { Repeat } from "sushiweb/Icons";

const TopActionBar = ({ id,refresh }) => {
  const [action, setAction] = useState("");
  const history = useHistory();


  return (
    <TopActionBarContainer className="mb-30">
      <LeftContainer justify="flex-start">
        <Back
          onClick={() => {
            history.replace("/disputes");
          }}
          className="mr-10 backBtn"
          color={variables.grey400}
        />
        <Breadcrumb className="sushi-breadcrumbs">
          <Breadcrumb.Link
            onClick={() => {
              history.replace("/disputes");
            }}
          >
            Disputes
          </Breadcrumb.Link>
          <Breadcrumb.Link>{id}</Breadcrumb.Link>
        </Breadcrumb>
      </LeftContainer>

      <RightContainer justify="flex-end">
        <Button
          icon={<Repeat />}
          appearance="outline"
          onClick={() => {
            refresh(id);
          }}
        >
          {" "}
          Refresh
        </Button>
      </RightContainer>
    </TopActionBarContainer>
  );
};

const TopActionBarContainer = styled(FlexContainer)`
  flex-direction: ${isMobile() ? "column" : "row"};
`;

const LeftContainer = styled(FlexContainer)`
  flex: 0 1 30%;
  margin-bottom: ${isMobile() ? "20px" : "unset"};
  & > div {
    flex-direction: ${isMobile() ? "row" : "column"};
  }
`;

const RightContainer = styled(FlexContainer)`
  flex: ${({ flexpct }) => (flexpct ? `0 1 ${flexpct}%` : "0 1 35%")};
  .actionDropdown {
    width: 100%;
    margin-bottom: unset;
  }
`;

export default TopActionBar;
